// contexts/FiltrosContext.jsx
import React, { createContext, useState, useContext } from "react";

const FiltrosContext = createContext();

export const FiltrosProvider = ({ children }) => {
    //Filtros
    const [pesquisa, setPesquisa] = useState("");
    const [edicao, setEdicao] = useState(undefined);
    const [categoria, setCategoria] = useState(undefined);
    const [ativo, setAtivo] = useState(true);
    // Drawer
    const [drawerVisivel, setDrawerVisivel] = useState(false);
    const [turmaId, setTurmaId] = useState(null);
    const [drawerDisciplinaVisivel, setDrawerDisciplinaVisivel] = useState(false);
    const [disciplinaId, setDisciplinaId] = useState(null);
    // Refresh trigger
    const [refreshKey, setRefreshKey] = useState(0);

    const triggerRefresh = () => setRefreshKey(prev => prev + 1);

    return (
        <FiltrosContext.Provider
            value={{
                pesquisa,
                setPesquisa,
                edicao,
                setEdicao,
                categoria,
                setCategoria,
                ativo,
                setAtivo,
                drawerVisivel,
                setDrawerVisivel,
                turmaId,
                setTurmaId,
                drawerDisciplinaVisivel,
                setDrawerDisciplinaVisivel,
                disciplinaId,
                setDisciplinaId,
                refreshKey,
                triggerRefresh
            }}
        >
            {children}
        </FiltrosContext.Provider>
    );
};

export const useFiltros = () => useContext(FiltrosContext);
